export default "__VITE_ASSET__CG17pMqX__"